module.exports = __webpack_public_path__ + "img/3MCircularTT-BookItalic.41ac070d.svg";